import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=1dee9ef2"
import script from "./DropdownButton.vue?vue&type=script&lang=js"
export * from "./DropdownButton.vue?vue&type=script&lang=js"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=1dee9ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports